import 'ui-core/plugins/transplant/js/transplant.js';
// @todo: move these changes to UX3 level to avoid appending li directly inside div (see LIT-286032 - LIT-303932).
let transplant = UX.transplant;
transplant.init = function () {
    let transArray = $('[data-toggle="transplant"]');

    transArray.each(function (index) {
        transplant.$element = $(this).data('transplant');
        transplant.$target = $($(this).data('target'));
        transplant.$direction = $($(this).data('direction'));
        transplant.$order = $(this).data('transplant-order');

        transplant.$remove = $(this).data('remove');
        transplant.$targetClass = $(this).data('target-class');
        transplant.$classNames = $(this).data('class-names');

        if (transplant.$direction === 'to' || typeof transplant.$direction === 'undefined') {
            if (transplant.$element === 'self') {
                transplant.$element = $(this);
            } else {
                transplant.$element = $(this).find(transplant.$element);
            }
            transplant.$cloneData = transplant.$element
                .clone(true, true)
                .removeAttr('data-toggle')
                .attr('data-transplant-order', transplant.$order);

            transplant.clone();
            if (transplant.$targetClass) {
                transplant.$target.find('.transplanted-clone').addClass(transplant.$targetClass);
            }
            if (transplant.$classNames) {
                transplant.$element.addClass(transplant.$classNames);
            }
            if (transplant.$remove === true) {
                transplant.remove();
            }
        } else {
            transplant.$target = $(this);
            transplant.dataTargetArray(transplant.$target);
        }
    });
    transplant.order();
};

transplant.dataTargetArray = function ($element) {
    let array = $element.data('target').split(','),
        arrayCount = 0;

    $.each(array, function (index, item) {
        if ($(item).length) {
            arrayCount += 1;
        }
    });
    $.each(array, function (index, item) {
        // go through selectors
        transplant.$element = $(item);
        transplant.$cloneData = transplant.$element.clone(true, true).attr('data-transplant-order', transplant.$order);
        transplant.clone(arrayCount);

        if (transplant.$targetClass) {
            transplant.$element.addClass(transplant.$targetClass);
        }

        if (transplant.$classNames) {
            transplant.$target.find('.transplanted-clone').addClass(transplant.$classNames);
        }
        if (transplant.$remove === true) {
            transplant.remove();
        }
    });
};

transplant.wrapElement = function ($element, htmlData) {
    let wrappedContent = $(htmlData);

    wrappedContent.append($element);
    return wrappedContent;
};

transplant.clone = function (arrayCount) {
    let content = null,
        $target = null,
        wrappedContent = null,
        wrapper = null,
        savedSearch = null;

    if (typeof arrayCount !== 'undefined') {
        if (transplant.$element.hasClass('cloned')) return;

        (content = transplant.$cloneData), ($target = transplant.$target), wrappedContent, wrapper;

        if (content.length) {
            wrapper = $target.find('.transplanted-clone');
            if (arrayCount > 1) {
                wrappedContent = !(content.is('li') || content.is('ul'))
                    ? transplant.wrapElement(
                          content.is('a') ? content : content.find('a').attr('role', 'menuitem'),
                          '<li role="presentation" ></li>'
                      )
                    : content;

                if (!wrapper.length) {
                    if (wrappedContent.is('ul')) {
                        wrappedContent
                            .addClass('transplanted-clone')
                            .attr('role', 'menu')
                            .find('li a')
                            .attr('role', 'menuitem')
                            .removeAttr('tabindex')
                            .removeAttr('data-toggle')
                            .removeAttr('aria-selected');
                        wrapper = wrappedContent;
                    } else {
                        wrapper = transplant.wrapElement(wrappedContent, '<ul class="transplanted-clone"></ul>');
                    }
                } else {
                    wrapper.append(wrappedContent);
                }
            } else if (arrayCount === 1) {
                if (content.is('li')) {
                    if (!wrapper.length) {
                        wrapper = transplant.wrapElement(content, '<ul class="transplanted-clone"></ul>');
                    }
                } else {
                    if (!wrapper.length) {
                        wrapper = transplant.wrapElement(content, '<div class="transplanted-clone"></div>');
                    }
                }
            }
            wrapper.find('a').removeAttr('tabindex');
            $target.append(wrapper);
        }
        transplant.$element.addClass('cloned');
        transplant.additionalControl();
    } else {
        UX.transplant.clone();
    }
    savedSearch = document.querySelectorAll("a[id='saveSearchTriggerButton']")[1];
    savedSearch?.setAttribute('id', savedSearch.getAttribute('id') + '-cloned');
    transplant.cleanDuplicateID();
};

transplant.order = function () {
    let clonedItems = transplant.$target.find('.transplanted-clone').children();

    clonedItems.sort(function (a, b) {
        return $(a).data('transplant-order') - $(b).data('transplant-order');
    });

    transplant.$target.find('.transplanted-clone').html(clonedItems);
};

transplant.additionalControl = function () {
    setTimeout(function () {
        $('.side-section-header.hiddenLabel--lg').each(function (index, $header) {
            if ($($header).next('[data-target]').children().length === 0) {
                $($header).remove();
            }
        });
    }, 250);
};

UX.transplant.init = transplant.init;
